import React, { Component } from 'react';

const Menu = ({onClick, title}) => {
    return(
        <div id="toogle-filter" data-title={title} onClick={onClick}></div>
    )
}

export default Menu;


// WEBPACK FOOTER //
// ./src/components/Menu.js